module.exports = __webpack_public_path__ + "static/media/move.9617ec2c.jpg";